/**
 * Main component for Feed Page
 *
 * @author Creator-Solutions -> Owen Burns
 */

import { FeedCard } from "@/components";
import { FeedPageContainer } from "./styling/feedPage.styles";
import FeedController from "./controller/feed.controller";

const FeedPage = () => {
  return (
    <FeedPageContainer>
      <FeedController />
    </FeedPageContainer>
  );
};

export default FeedPage;
